import React from 'react'
import { useBrandFilter } from '../../contexts/brand-filter-context'
import useDocumentTitle from '../../hooks/useDocumentTitle'
import './DivisionSelector.css'

const DivisionSelector = () => {
  useDocumentTitle('Select Division')
  const { setBrand: setDivision } = useBrandFilter()

  return (
    <div className="division-selector-page">
      <div className="division-selector-content">
        <div className="division-selector-header">
          <img src="logo/short_circuit.png" alt="Short Circuit" className="division-logo" />
          <h1 className="division-title">Welcome to Short Circuit</h1>
          <p className="division-subtitle">Select your division to get started</p>
        </div>

        <div className="division-cards">
          <button
            className="division-card division-card-edc"
            onClick={() => setDivision('EDC')}
          >
            <div className="division-card-logo">
              <img src="logo/edc-logo.svg" alt="EDC" className="division-brand-logo edc-brand-logo" />
            </div>
            <p className="division-card-desc">
              Edward Davies Commercials Ltd. — All projects and design work
            </p>
            <span className="division-card-action">Enter EDC &rarr;</span>
          </button>

          <button
            className="division-card division-card-msrt"
            onClick={() => setDivision('MS-RT')}
          >
            <div className="division-card-logo">
              <img src="logo/ford-x-msrt-logo.svg" alt="MS-RT" className="division-brand-logo msrt-brand-logo" />
            </div>
            <p className="division-card-desc">
              Ford vehicle projects — Performance & aftermarket design
            </p>
            <span className="division-card-action">Enter MS-RT &rarr;</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default DivisionSelector
